import { Box, getVariant } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { IAttachment } from '../types';
import { FileAttachment } from './FileAttachment';

export const Attachments = observer(
  ({
    attachments,
    onRemove,
    onAddDescription,
    className,
  }: {
    attachments: IAttachment[];
    onRemove?: (a: IAttachment) => unknown;
    onAddDescription?: (a: IAttachment, d: string) => unknown;
    className?: string;
  }) => {
    if (!attachments.length) return null;

    return (
      <Box
        className={`attachments ${className}`}
        {...getVariant('layout.common.chat.attachments')}
      >
        {attachments.map((x) => (
          <FileAttachment
            attachment={x}
            onRemove={onRemove ? () => onRemove(x) : undefined}
            onAddDescription={onAddDescription}
            key={x.id}
          />
        ))}
      </Box>
    );
  },
);
